
var gHome = 'linear-gradient(to bottom, #FFC3C3 0%, #FEFCF3 100%)';
var gAbout = 'linear-gradient(to bottom, #FF9F9F 0%, #FEFCF3 100%)';
var gFAQ = 'linear-gradient(to bottom, #fec0ac 0%, #FEFCF3 100%)';
var gBlog = 'linear-gradient(to bottom, #ffad86 0%, #FEFCF3 100%)';

export { gHome, gAbout, gFAQ, gBlog };